export default __webpack_public_path__ + "static/media/money.60b1366a.svg";